import { call, put, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  CREATE_MOTORBIKE,
  CREATE_MOTORBIKE_FAILURE,
  CREATE_MOTORBIKE_SUCCESS,
  CreateMotorbikeActionType,
  FETCH_MOTORBIKES
} from 'src/redux/motorbikesReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* CreateMotorbikeFlow(action: CreateMotorbikeActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = '/dealers_api/motorbikes'
    yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: POST,
      params: {
        motorbike: action.payload
      }
    })
    yield put(CREATE_MOTORBIKE_SUCCESS())
    yield put(
      SHOW_TOAST({
        message: t('my_vehicles.toast_vehicle_added'),
        actionLabel: t('my_vehicles.toast_issue_invoice'),
        actionPath: '/selling/clients'
      })
    )
    yield put(FETCH_MOTORBIKES())
  } catch (error) {
    yield put(CREATE_MOTORBIKE_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* CreateMotorbikeSaga(): Generator<any, void, any> {
  yield takeLatest(CREATE_MOTORBIKE, CreateMotorbikeFlow)
}
